import { render, staticRenderFns } from "./BannerMain.vue?vue&type=template&id=97af25f8&scoped=true"
import script from "./BannerMain.vue?vue&type=script&lang=js"
export * from "./BannerMain.vue?vue&type=script&lang=js"
import style0 from "./BannerMain.vue?vue&type=style&index=0&id=97af25f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97af25f8",
  null
  
)

export default component.exports